import React, { Fragment } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import { SITENAMEALIAS } from "../utils/init";
import {
  showToast,
  showHttpError,
  formatAmount,
  handleDynamicCurrencyDetiails,
} from "../utils/library";
import {
  FetchUsdBtcLedgerAmount,
  GetMerchantSettings,
  SetMerchantSettings,
} from "../utils/service";

const S = {
  pageWrapper: { padding: "36px 24px 60px" },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "28px",
    flexWrap: "wrap",
    gap: "16px",
  },
  pageTitle: {
    fontSize: "24px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
  },
  pageSubtitle: { fontSize: "13px", opacity: 0.5, margin: "4px 0 0" },
  card: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid var(--body-color-less2)",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    marginBottom: "24px",
    padding: "24px",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "20px",
  },
  cardHeaderLeft: { display: "flex", alignItems: "center", gap: "14px" },
  iconBox: {
    width: "42px",
    height: "42px",
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "18px",
    flexShrink: 0,
    background: "rgba(245,158,11,0.1)",
    color: "#f59e0b",
  },
  sectionTitle: {
    fontSize: "16px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
  },
  sectionDesc: { fontSize: "12px", opacity: 0.5, margin: "2px 0 0" },
  infoBox: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "16px 20px",
    borderRadius: "10px",
    background:
      "linear-gradient(135deg, rgba(245,158,11,0.06), rgba(245,158,11,0.02))",
    border: "1px solid rgba(245,158,11,0.15)",
    marginBottom: "24px",
  },
  selectorRow: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    marginBottom: "24px",
  },
  label: {
    fontSize: "12px",
    fontWeight: "600",
    textTransform: "uppercase",
    letterSpacing: "0.3px",
    color: "var(--text-color)",
    opacity: 0.7,
    marginBottom: "8px",
    display: "block",
  },
  select: {
    padding: "10px 14px",
    fontSize: "14px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
    maxWidth: "360px",
  },
  input: {
    padding: "10px 14px",
    fontSize: "14px",
    borderRadius: "10px",
    border: "1px solid var(--body-color-less2)",
    background: "var(--body-color)",
    color: "var(--text-color)",
    outline: "none",
    width: "100%",
    boxSizing: "border-box",
  },
  toleranceCard: {
    background: "var(--body-color)",
    borderRadius: "12px",
    border: "1px solid var(--body-color-less2)",
    padding: "20px",
    marginBottom: "16px",
  },
  toleranceHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    marginBottom: "14px",
  },
  toleranceTitle: {
    fontSize: "14px",
    fontWeight: "700",
    color: "var(--text-color)",
    display: "flex",
    alignItems: "center",
    gap: "8px",
  },
  toleranceDesc: {
    fontSize: "12px",
    opacity: 0.55,
    lineHeight: "1.6",
    marginBottom: "16px",
  },
  checkRow: {
    display: "flex",
    alignItems: "center",
    gap: "10px",
    marginBottom: "14px",
    cursor: "pointer",
  },
  btnPrimary: {
    padding: "10px 24px",
    background: "var(--btn-color)",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: "6px",
  },
  btnOutline: {
    padding: "10px 24px",
    background: "transparent",
    border: "1px solid var(--body-color-less2)",
    color: "var(--text-color)",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    opacity: 0.6,
  },
};

class PaymentTolerance extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      assets: [],
      selectedCurrencyId: "2",
      isAutomaticAcceptUnderpayment: false,
      underPaymentToleranceLimit: "",
      isAutomaticAcceptOverpayment: false,
      overPaymentToleranceLimit: "",
    };
  }

  componentDidMount() {
    this.loadAssets();
  }

  loadAssets = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
    };
    this.setState({ showLoader: true });
    FetchUsdBtcLedgerAmount(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            if (response != null) {
              let coinBalance = response.coin_balance;
              let arr = [];
              if (coinBalance) {
                for (let i = 0; i < coinBalance.length; i++) {
                  if (String(coinBalance[i].currency_type) === "2") {
                    arr.push({
                      assetName: coinBalance[i].currency_name,
                      coinBalance: coinBalance[i].balance,
                      assetCode: coinBalance[i].currency_code,
                      assetId: coinBalance[i].currency_id,
                      assetImage: coinBalance[i].logo,
                      network: coinBalance[i].network,
                      isBrokerCurrency: coinBalance[i].is_broker_currency,
                    });
                  }
                }
              }
              this.setState({ assets: arr }, () => {
                if (arr.length > 0) {
                  this.setState(
                    { selectedCurrencyId: String(arr[0].assetId) },
                    () => {
                      this.loadSettings(this.state.selectedCurrencyId);
                    }
                  );
                }
              });
            }
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  loadSettings = (currencyId) => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      currency_id: currencyId,
    };
    this.setState({ showLoader: true });
    GetMerchantSettings(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            this.setState({
              underPaymentToleranceLimit: formatAmount(
                response.underpayment_tolerance,
                2
              ),
              overPaymentToleranceLimit: formatAmount(
                response.overpayment_tolerance,
                2
              ),
              isAutomaticAcceptOverpayment:
                response.accept_overpayments != "" &&
                response.accept_overpayments != null &&
                response.accept_overpayments != "no",
              isAutomaticAcceptUnderpayment:
                response.accept_underpayments != "" &&
                response.accept_underpayments != null &&
                response.accept_underpayments != "no",
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  handleSave = () => {
    let payload = {
      merchant_id: localStorage.getItem(SITENAMEALIAS + "_merchant_id"),
      currency_id: this.state.selectedCurrencyId,
      overpayment_tolerance: formatAmount(
        this.state.overPaymentToleranceLimit,
        5
      ),
      underpayment_tolerance: formatAmount(
        this.state.underPaymentToleranceLimit,
        5
      ),
      accept_underpayments: this.state.isAutomaticAcceptUnderpayment
        ? "yes"
        : "no",
      accept_overpayments: this.state.isAutomaticAcceptOverpayment
        ? "yes"
        : "no",
    };
    this.setState({ showLoader: true });
    SetMerchantSettings(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data[0];
          if (response.error != "0") {
            showToast("error", response.error_msg);
          } else {
            showToast(
              "success",
              "Payment tolerance settings saved successfully"
            );
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  getAssetCode = () => {
    if (this.state.assets.length > 0) {
      const info = handleDynamicCurrencyDetiails(
        this.state.assets,
        this.state.selectedCurrencyId
      );
      return info ? info.assetCode : "";
    }
    return "";
  };

  render() {
    const assetCode = this.getAssetCode();
    const canSave =
      this.state.overPaymentToleranceLimit !== "" ||
      this.state.isAutomaticAcceptOverpayment ||
      this.state.underPaymentToleranceLimit !== "" ||
      this.state.isAutomaticAcceptUnderpayment;

    return (
      <Fragment>
        <div className="container-scroller">
          <Sidebar />
          <Header />
          <div className="main-panel">
            <div style={S.pageWrapper}>
              {/* Header */}
              <div style={S.headerRow}>
                <div>
                  <h2 style={S.pageTitle}>Payment Tolerance</h2>
                  <div style={S.pageSubtitle}>
                    Configure how overpayments and underpayments are handled
                  </div>
                </div>
              </div>

              {/* Main Card */}
              <div style={S.card}>
                <div style={S.cardHeader}>
                  <div style={S.cardHeaderLeft}>
                    <div style={S.iconBox}>
                      <i
                        className="mdi mdi-alert-circle-outline"
                        style={{ fontSize: 20 }}
                      ></i>
                    </div>
                    <div>
                      <h3 style={S.sectionTitle}>Tolerance Settings</h3>
                      <p style={S.sectionDesc}>
                        Define thresholds for automatic payment acceptance
                      </p>
                    </div>
                  </div>
                </div>

                {/* Info box */}
                <div style={S.infoBox}>
                  <i
                    className="mdi mdi-information-outline"
                    style={{
                      color: "#f59e0b",
                      fontSize: "18px",
                      flexShrink: 0,
                    }}
                  ></i>
                  <div>
                    <span style={{ fontSize: "13px", fontWeight: "600" }}>
                      Overpayments and Underpayments
                    </span>
                    <p
                      style={{
                        fontSize: "12px",
                        opacity: 0.6,
                        margin: "4px 0 0",
                      }}
                    >
                      Configure tolerance thresholds per currency. When a
                      payment falls within the defined range, it will be
                      automatically accepted or adjusted.
                    </p>
                  </div>
                </div>

                {/* Currency Selector */}
                <div style={{ marginBottom: "24px" }}>
                  <label style={S.label}>Select Currency</label>
                  <select
                    style={S.select}
                    value={this.state.selectedCurrencyId}
                    onChange={(e) => {
                      this.setState(
                        { selectedCurrencyId: e.target.value },
                        () => {
                          this.loadSettings(this.state.selectedCurrencyId);
                        }
                      );
                    }}
                  >
                    {this.state.assets.map((iter) => (
                      <option key={iter.assetId} value={iter.assetId}>
                        {iter.assetCode} - {iter.assetName}
                      </option>
                    ))}
                  </select>
                </div>

                {/* Underpayment */}
                <div style={S.toleranceCard}>
                  <div style={S.toleranceHeader}>
                    <div style={S.toleranceTitle}>
                      <i
                        className="mdi mdi-arrow-down-circle"
                        style={{ color: "#ef4444", fontSize: "18px" }}
                      ></i>
                      Underpayments
                    </div>
                  </div>
                  <p style={S.toleranceDesc}>
                    An invoice price automatically adjusts down so it counts as
                    fully paid if the underpaid amount is within the threshold
                    you define.
                  </p>
                  <label
                    style={S.checkRow}
                    onClick={() =>
                      this.setState({
                        isAutomaticAcceptUnderpayment:
                          !this.state.isAutomaticAcceptUnderpayment,
                      })
                    }
                  >
                    <input
                      type="checkbox"
                      checked={this.state.isAutomaticAcceptUnderpayment}
                      onChange={() => {}}
                      style={{
                        width: "16px",
                        height: "16px",
                        accentColor: "var(--btn-color)",
                        cursor: "pointer",
                      }}
                    />
                    <span style={{ fontSize: "13px", fontWeight: "600" }}>
                      Automatically accept Underpayments
                    </span>
                  </label>
                  <div>
                    <label style={S.label}>
                      Underpayment tolerance limit
                      {assetCode ? ` (IN % OF INVOICE AMOUNT)` : ""}
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      style={S.input}
                      placeholder="Enter underpayment tolerance limit"
                      value={this.state.underPaymentToleranceLimit}
                      onChange={(e) => {
                        let val = e.target.value;
                        if (val.includes(".") && val.split(".")[1]?.length > 2) {
                          val = parseFloat(val).toFixed(2);
                        }
                        this.setState({ underPaymentToleranceLimit: val });
                      }}
                    />
                  </div>
                </div>

                {/* Overpayment */}
                <div style={S.toleranceCard}>
                  <div style={S.toleranceHeader}>
                    <div style={S.toleranceTitle}>
                      <i
                        className="mdi mdi-arrow-up-circle"
                        style={{ color: "#10b981", fontSize: "18px" }}
                      ></i>
                      Overpayments
                    </div>
                  </div>
                  <p style={S.toleranceDesc}>
                    If a customer overpays, the system can automatically credit
                    the extra funds to your ledger if the overpaid amount is
                    within the tolerance threshold.
                  </p>
                  <label
                    style={S.checkRow}
                    onClick={() =>
                      this.setState({
                        isAutomaticAcceptOverpayment:
                          !this.state.isAutomaticAcceptOverpayment,
                      })
                    }
                  >
                    <input
                      type="checkbox"
                      checked={this.state.isAutomaticAcceptOverpayment}
                      onChange={() => {}}
                      style={{
                        width: "16px",
                        height: "16px",
                        accentColor: "var(--btn-color)",
                        cursor: "pointer",
                      }}
                    />
                    <span style={{ fontSize: "13px", fontWeight: "600" }}>
                      Automatically accept Overpayments
                    </span>
                  </label>
                  <div>
                    <label style={S.label}>
                      Overpayment tolerance limit
                      {assetCode ? ` (IN % OF INVOICE AMOUNT)` : ""}
                    </label>
                    <input
                      type="number"
                      step="0.01"
                      style={S.input}
                      placeholder="Enter overpayment tolerance limit"
                      value={this.state.overPaymentToleranceLimit}
                      onChange={(e) => {
                        let val = e.target.value;
                        if (val.includes(".") && val.split(".")[1]?.length > 2) {
                          val = parseFloat(val).toFixed(2);
                        }
                        this.setState({ overPaymentToleranceLimit: val });
                      }}
                    />
                  </div>
                </div>

                {/* Actions */}
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "10px",
                    paddingTop: "8px",
                  }}
                >
                  <button
                    style={S.btnPrimary}
                    onClick={this.handleSave}
                    disabled={!canSave}
                  >
                    <i className="mdi mdi-check"></i> Save Settings
                  </button>
                </div>
              </div>
            </div>
            <Footer />
          </div>
          <Loader show={this.state.showLoader} />
        </div>
      </Fragment>
    );
  }
}

export default PaymentTolerance;
